export enum LOCAL_STORAGE_KEYS {
  TOKEN = "WEB2MSG_TOKEN",
  SHARED_TOKEN = "WEB2MSG_SHARED_TOKEN",
  AUTH = "WEB2MSG_AUTH",
  CONFIG = "config",
  VALIDATED_ID = "validated-id",
}
